<template>
  <div class="section-card">
    <p class="section-title mb-0 pa-1 pl-5">
      Información del programa:
      <a class="btn btn-default section-toggle" data-toggle="collapse" href="#collapseinfor">expandir</a>
    </p>
    <div class="collapse in section-body" id="collapseinfor">

      <!-- Estado y fecha registro -->
      <v-card outlined class="mb-3">
        <v-card-text class="pa-3 d-flex flex-wrap justify-end align-center">
          <div class="d-flex align-center mx-2">
            <v-icon color="deep-purple accent-4" class="mr-2">mdi-information-outline</v-icon>
            <div>
              <div class="text-caption grey--text text--darken-1 mb-1">Estado del Programa</div>
              <v-chip v-if="programa.estado" small color="deep-purple accent-4" dark label class="font-weight-medium">
                {{ programa.estado }}
              </v-chip>
              <v-chip v-else small outlined color="grey" label>
                <v-icon left x-small>mdi-help-circle</v-icon>Sin estado
              </v-chip>
            </div>
          </div>
          <div class="d-flex align-center mx-2">
            <v-icon color="blue darken-2" class="mr-2">mdi-calendar-clock</v-icon>
            <div>
              <div class="text-caption grey--text text--darken-1 mb-1">Fecha de Registro</div>
              <v-chip v-if="programa.fecha_registro" small color="blue darken-2" dark label class="font-weight-medium">
                {{ programa.fecha_registro }}
              </v-chip>
              <v-chip v-else small outlined color="grey" label>
                <v-icon left x-small>mdi-calendar-remove</v-icon>Sin fecha
              </v-chip>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <!-- Nombres -->
      <v-row dense class="mb-2">
        <v-col cols="12" md="8">
          <v-text-field v-model.trim="programa.nombre_compuesto" label="* Nombre compuesto"
            :readonly="onlyReadAcade" placeholder="Ingrese el nombre compuesto..." dense outlined hide-details />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="programa.nombre_corto" :readonly="onlyReadAcade" label="* Nombre corto"
            placeholder="Máximo 60 caracteres" dense outlined counter="60" maxlength="60" hide-details />
        </v-col>
      </v-row>

      <!-- Fechas y gestión -->
      <v-row dense class="mb-2">
        <v-col cols="12" sm="6" md="3">
          <v-text-field v-model.trim="programa.fecha_matricula" :readonly="onlyReadAcade"
            type="date" label="* Fecha inicio matriculaciones" dense outlined hide-details />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field v-model.trim="programa.fecha_inicio" :readonly="onlyReadAcade"
            type="date" label="* Fecha inicio del programa" dense outlined hide-details />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field v-model.trim="programa.fecha_fin" :readonly="onlyReadAcade"
            type="date" label="Fecha fin del programa" dense outlined hide-details />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field v-model.number="programa.gestion" :readonly="onlyReadAcade"
            type="number" label="* Gestión del programa" placeholder="Ej: 2024" dense outlined hide-details />
        </v-col>
      </v-row>

      <!-- Sede, modalidad, versión, grupo, nota -->
      <v-row dense class="mb-2">
        <v-col cols="12" sm="4" md="6">
          <v-select v-model="programa.sede_id" :items="sedesFiltradas" :readonly="onlyReadAcade"
            item-text="nombre" item-value="id" label="* Sede del programa" dense outlined hide-details />
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-select v-model.trim="programa.modalidad" :readonly="onlyReadAcade"
            :items="[{text:'Presencial',value:'P'},{text:'Virtual',value:'V'},{text:'Semipresencial',value:'S'}]"
            label="* Modalidad" dense outlined hide-details />
        </v-col>
        <v-col cols="12" sm="2" md="1">
          <v-text-field v-model.number="programa.version" :readonly="onlyReadAcade"
            type="number" label="* Versión" dense outlined hide-details />
        </v-col>
        <v-col cols="12" sm="2" md="1">
          <v-text-field v-model.number="programa.grupo" :readonly="onlyReadAcade"
            type="number" label="* Grupo" dense outlined hide-details />
        </v-col>
        <v-col cols="12" sm="2" md="1">
          <v-text-field v-model.number="programa.nota_aprobacion" :readonly="onlyReadAcade"
            type="number" label="* Nota mínima" placeholder="Ej: 71" dense outlined hide-details />
        </v-col>
      </v-row>

      <!-- Coordinador y responsable -->
      <v-row dense class="mb-4">
        <v-col cols="12" md="6">
          <Usuarios :current="false" :model="coordinadorsel" :xdefault="programa.coordinador.coordinador_id" :readonly="onlyReadAcade" />
          <label class="caption grey--text ml-1">Coordinador de marketing</label>
        </v-col>
        <v-col cols="12" md="6">
          <Usuarios :current="false" :model="responsablesel" :xdefault="programa.responsable.responsable_id" :readonly="onlyReadAcade" />
          <label class="caption grey--text ml-1">Responsable Academico</label>
        </v-col>
      </v-row>

      <v-divider class="my-4" />

      <!-- Universidad/convenio -->
      <v-select v-if="$store.state.CARGO.sede.unidad_negocio != 1"
        :items="convenios" v-model="universidadsel"
        item-text="nombre" item-value="id" label="Universidad/Certificación"
        outlined dense hide-details return-object class="mb-3" style="max-width: 500px" />

      <v-alert v-if="universidadsel && universidadsel.id" type="info" dense text class="mb-2">
        <strong>Convenio:</strong> ({{ universidadsel.abreviatura }}) {{ universidadsel.nombre }}
      </v-alert>
      <v-alert dense text type="info" class="mb-2">
        <strong>Unidad de negocio:</strong> {{ $store.state.UNIDAD_NEGOCIO_ID }}
      </v-alert>

      <v-divider class="my-2" />

      <!-- Beneficiencia -->
      <v-card outlined class="mb-4">
        <v-card-text>
          <v-row align="center">
            <v-col cols="auto"><v-icon color="purple">mdi-information</v-icon></v-col>
            <v-col><span class="font-weight-medium">Si el programa es de beneficiencia sin fines de lucro, active esta opción:</span></v-col>
            <v-col cols="12" sm="auto">
              <v-switch v-model="programa.is_campania" label="Curso de beneficiencia"
                :readonly="!isPermBenefi" color="purple" hide-details class="mt-0" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Proyecto asignado -->
      <v-progress-linear v-if="loadingproy" indeterminate color="primary" class="mb-4" />
      <v-card v-if="proyectoasig" outlined class="mb-4">
        <v-card-title class="green white--text py-2">
          <v-icon left color="white">mdi-check-circle</v-icon>Proyecto Asignado
        </v-card-title>
        <v-card-text class="pt-3">
          <v-row dense>
            <v-col cols="12" sm="6" md="4"><div class="text-caption grey--text">Código</div><div class="font-weight-medium">{{ proyectoasig.codigo }}</div></v-col>
            <v-col cols="12" sm="6" md="8"><div class="text-caption grey--text">Proyecto</div><div class="font-weight-medium">{{ proyectoasig.programa }}</div></v-col>
            <v-col cols="12" sm="6" md="3"><div class="text-caption grey--text">Gestión</div><div>{{ proyectoasig.gestion }}</div></v-col>
            <v-col cols="12" sm="6" md="3"><div class="text-caption grey--text">Versión</div><div>{{ proyectoasig.version }}</div></v-col>
            <v-col cols="12" sm="6" md="6"><div class="text-caption grey--text">Área</div><div>{{ proyectoasig.area }}</div></v-col>
            <v-col cols="12" sm="6" md="4"><div class="text-caption grey--text">Fecha inicio</div><div>{{ proyectoasig.fecha_inicio }}</div></v-col>
            <v-col cols="12" sm="6" md="4"><div class="text-caption grey--text">Fecha culminación</div><div>{{ proyectoasig.fecha_culminacion }}</div></v-col>
            <v-col cols="12" sm="6" md="4"><div class="text-caption grey--text">Estado</div><v-chip small color="success" text-color="white">{{ proyectoasig.estado_programa }}</v-chip></v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-divider class="my-4" />

      <!-- Imágenes -->
      <v-row>
        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-title class="py-3 primary white--text">
              <v-icon left style="color:white!important">mdi-image</v-icon>
              Portada del Programa
              <v-chip x-small color="error" class="ml-2">Requerido</v-chip>
            </v-card-title>
            <v-card-text class="text-center pa-4">
              <v-file-input ref="imagenportada" v-model="archivoPortada" accept="image/*"
                :disabled="cargandoportada || onlyReadAcade"
                label="Seleccione un archivo de portada" prepend-icon="mdi-camera"
                dense outlined hide-details @change="$emit('imagen-select', 1)" class="mb-3" />
              <v-btn :disabled="portadasel || onlyReadAcade" :loading="cargandoportada" color="primary" small @click="$emit('subir-imagen', 1)">
                <v-icon left small>mdi-upload</v-icon>Subir Imagen
              </v-btn>
              <v-alert v-if="subidores" dense text type="success" class="mt-3">Imagen subida correctamente</v-alert>
              <v-img v-if="programa.portada" :src="locationPortadas + programa.portada" alt="PORTADA" class="mt-3" max-height="300" contain />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-title class="py-3 secondary white--text">
              <v-icon left color="white">mdi-certificate</v-icon>Certificado del Programa
            </v-card-title>
            <v-card-text class="text-center pa-4">
              <v-file-input ref="imagencertificado" v-model="archivoCertificado" accept="image/*"
                :disabled="cargandocertificado || onlyReadAcade"
                label="Seleccione el fondo del certificado" prepend-icon="mdi-camera"
                dense outlined hide-details @change="$emit('imagen-select', 2)" class="mb-3" />
              <v-btn :disabled="certificadosel || onlyReadAcade" :loading="cargandocertificado" color="secondary" small @click="$emit('subir-imagen', 2)">
                <v-icon left small>mdi-upload</v-icon>Subir Imagen
              </v-btn>
              <v-alert v-if="subidores1" dense text type="success" class="mt-3">Imagen subida correctamente</v-alert>
              <v-img v-if="programa.arte" :src="locationCertificados + programa.arte" alt="CERTIFICADO" class="mt-3" max-height="300" contain />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Usuarios from '@/components/AUsuariosActivos';
export default {
  name: 'SeccionInfo',
  components: { Usuarios },
  props: {
    programa: { type: Object, required: true },
    sedesFiltradas: { type: Array, default: () => [] },
    convenios: { type: Array, default: () => [] },
    universidadsel: { type: Object, default: () => ({}) },
    coordinadorsel: { type: Object, required: true },
    responsablesel: { type: Object, required: true },
    proyectoasig: { type: Object, default: null },
    loadingproy: { type: Boolean, default: false },
    onlyReadAcade: { type: Boolean, default: false },
    isPermBenefi: { type: Boolean, default: false },
    archivoPortada: { default: null },
    archivoCertificado: { default: null },
    portadasel: { type: Boolean, default: true },
    certificadosel: { type: Boolean, default: true },
    cargandoportada: { type: Boolean, default: false },
    cargandocertificado: { type: Boolean, default: false },
    subidores: { type: Boolean, default: false },
    subidores1: { type: Boolean, default: false },
    locationPortadas: { type: String, default: '' },
    locationCertificados: { type: String, default: '' },
  },
};
</script>

<style scoped>
.section-card { background:#fff; border:1px solid #e6e9f0; border-radius:12px; padding:14px 14px 6px; margin-top:16px; box-shadow:0 4px 12px rgba(0,0,0,.04); }
.section-title { display:flex; align-items:center; justify-content:space-between; border-radius:10px; background:linear-gradient(90deg,#e3f2fd 0%,#ede7f6 100%); color:#1e3a8a; font-weight:600; }
.section-toggle { color:#3949ab; font-weight:600; }
.section-body { padding-top:10px; }
</style>
